import React from 'react';
import SvgIcon from './SvgIcon';

const EpidemicPandemic = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M12 23.25c3.334 0 6.037-5.037 6.037-11.25S15.334.75 12 .75C8.665.75 5.962 5.787 5.962 12S8.665 23.25 12 23.25zM12 .75v22.5M1.687 16.5h20.625H1.688zm0-9h20.625H1.688z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

EpidemicPandemic.displayName = 'EpidemicPandemicIcon';

export default EpidemicPandemic;
